<template>
  <mw-dialog ref="dialog" :appendToBody="false" :title="title" size="large_large" >
    <div class="mw-margin-top-10 process-dialog">
      <MwFlowInterferingTable :filterParams="params"></MwFlowInterferingTable>
    </div>
  </mw-dialog>
</template>

<script>
    import MwFlowInterferingTable from '@/modules/index/views/systemSet/set/flowInterfering/rightPanel.vue';
    export default {
        name: "process-interfering",
        data() {
          return {
            title:"流程干预"
          }
        },
        props:{
          params:{
            type:Object
          }
        },
        mounted() {
          setTimeout(()=>{
            this.show();
          },200)
        },
        methods: {
          show() {
            this.mwRef('dialog').show();
          }
        },
        components: {
          MwFlowInterferingTable
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/modules/index/components/public-dialog/process-interfering.vue